// extracted by mini-css-extract-plugin
export default {"table":"sales-section_table__LbekO","labelCell":"sales-section_labelCell__aN1ti"};